<template>
  <div class="update subpage" ref="updateRef">
    <Header title="版本更新" :is-sub-page="true"></Header>
    <div class="versionInfo">
        <div class="currentVersion">
          <span>当前版本:</span>
          <span>V{{this.curVersion}}</span>
        </div>
        <div class="nextVersion">
          <span>最新版本:</span>
          <span>V{{this.lastVersion}}</span>
        </div>
    </div>
    <div class="update-Btn" @click="doUpdate">
        <span :class="[this.canUpdate?'update-font':'update-font-disable']" >更新</span>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
import { queryVersion, getApp } from '@/api/version'

export default {
  name: '',
  data () {
    return {
      'curVersion': '2.1',
      'lastVersion': '2.2',
      'canUpdate': true
    }
  },
  components: {
    Header
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      this.curVersion = this.$store.state.token.version

      queryVersion({}).then((res) => {
        this.lastVersion = res.data.version
        this.canUpdate = this.isNeedUpdate()
      })
    },

    isNeedUpdate () {
      try {
        var curStr = this.curVersion.split('.')
        var lastStr = this.lastVersion.split('.')
        console.log('curStr=' + JSON.stringify(curStr))
        console.log('lastStr=' + JSON.stringify(lastStr))
        if (parseInt(lastStr[0]) > parseInt(curStr[0])) {
          return true
        } else if (parseInt(lastStr[0]) === parseInt(curStr[0]) && parseInt(lastStr[1]) > parseInt(curStr[1])) {
          return true
        } else if (parseInt(lastStr[0]) === parseInt(curStr[0]) && parseInt(lastStr[1]) === parseInt(curStr[1]) &&
        parseInt(lastStr[2]) > parseInt(curStr[2])) {
          return true
        } else {
          return false
        }
      } catch (e) {
        return false
      }
    },
    doUpdate () {
      console.log('doUpdate')
      if (this.canUpdate) {
        window.location.href = 'http://juece.oss-cn-shanghai.aliyuncs.com/1573720777278_Dfzh_envTest_v0.0.0_2019-11-14_debug.apk'
        getApp({}).then((res) => {
          console.log('update url =' + res.data.url)
          this.$dfzhJsBridge.update({
            'url': res.data.url
          })
        })
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.update
  .versionInfo
    margin-top 150px
    font-size 16px
    color black
    .nextVersion
      margin-top 10px
  .update-Btn
    margin-top 280px
    font-size 19px
    width 100%
    height 44px
    color #fff
    display flex
    justify-content center
    .update-font
      border-radius 5px
      background-color #874DD5
      height 44px
      width 301px
      display flex
      justify-content center
      align-items center
    .update-font-disable
      border-radius 5px
      background-color #CFCFCF
      height 44px
      width 301px
      display flex
      justify-content center
      align-items center
</style>

<style lang="stylus">
body
  background-color #f7f7f7
</style>
